import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";

const AREA_ID = "area";

export function useAreaFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: AREA_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: AREA_ID,
      title: t("areaString"),
      options: [
        {
          value: "showroomOW",
          title: t("showroomOWString"),
        },
        {
          value: "markethallOW",
          title: t("markethallOWString"),
        },
        {
          value: "otherAreaCashline",
          title: t("cashlineString"),
        },
      ],
      enabled: true,
      defaultValue,
    },
    t("wholeStoreString")
  );
}
